// extracted by mini-css-extract-plugin
module.exports = {"folder":"ItemFolder_folder__3sJKj","folder_clickable":"ItemFolder_folder_clickable__2IF0Y","content":"ItemFolder_content__3y0-1"};